module.exports = __webpack_public_path__ + "static/media/9.2367dcc1.JPG";